import cn from 'classnames';

import style from 'styles/components/mealDetails/NutritionFactsPanel.module.scss';

const SingleColumnNutritionTableContentRow = ({
  displayPercent,
  isHeader,
  percentAsPackaged,
  rowClass,
  title,
  valueAsPackaged,
  addedSugarsRow,
}) => {
  return (
    <tr className={cn(rowClass, { [style.addedSugarsBorder]: addedSugarsRow })}>
      <th
        scope="row"
        colSpan={displayPercent ? '2' : '3'}
        className={cn({
          [style.additionalPadding]: !isHeader,
          [style.addedSugarsPadding]: addedSugarsRow,
        })}
      >
        <span className={cn({ [style.helvBlk]: isHeader })}>{title}</span>
        <span> {valueAsPackaged}</span>
      </th>
      {displayPercent && (
        <td className={cn([style.tdPercent, style.helvBlk])}>{percentAsPackaged}</td>
      )}
    </tr>
  );
};

SingleColumnNutritionTableContentRow.propTypes = {
  displayPercent: PropTypes.bool.isRequired,
  isHeader: PropTypes.bool.isRequired,
  percentAsPackaged: PropTypes.string.isRequired,
  rowClass: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  valueAsPackaged: PropTypes.string.isRequired,
  addedSugarsRow: PropTypes.bool.isRequired,
};

const ThreeColumnNutritionTableContentRow = ({
  displayPercent,
  isHeader,
  percentAsPackaged,
  percentAsPrepared,
  rowClass,
  title,
  valueAsPackaged,
  valueAsPrepared,
}) => {
  const columnSpan = displayPercent ? 1 : 2;

  return (
    <tr className={rowClass}>
      <th scope="row" className={cn({ [style.helvBlk]: isHeader })}>
        {title}
      </th>
      <td colSpan={columnSpan} className={style.tdGrams}>
        {valueAsPackaged}
      </td>
      {displayPercent && (
        <td className={cn([style.tdPercent, style.helvBlk])}>{percentAsPackaged}</td>
      )}
      <td colSpan={columnSpan} className={style.tdGrams}>
        {valueAsPrepared}
      </td>
      {displayPercent && (
        <td className={cn([style.tdPercent, style.helvBlk])}>{percentAsPrepared}</td>
      )}
    </tr>
  );
};

ThreeColumnNutritionTableContentRow.propTypes = {
  displayPercent: PropTypes.bool.isRequired,
  isHeader: PropTypes.bool.isRequired,
  percentAsPackaged: PropTypes.string.isRequired,
  percentAsPrepared: PropTypes.string.isRequired,
  rowClass: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  valueAsPackaged: PropTypes.string.isRequired,
  valueAsPrepared: PropTypes.string.isRequired,
};

const NutritionTableContentRow = ({
  displayPercent,
  displayPreparedNutritionInfo,
  isHeader,
  percentAsPackaged,
  percentAsPrepared,
  rowClass,
  title,
  valueAsPackaged,
  valueAsPrepared,
  addedSugarsRow,
}) => {
  if (displayPreparedNutritionInfo) {
    return (
      <ThreeColumnNutritionTableContentRow
        displayPercent={displayPercent}
        isHeader={isHeader}
        percentAsPackaged={percentAsPackaged}
        percentAsPrepared={percentAsPrepared}
        rowClass={rowClass}
        title={title}
        valueAsPackaged={valueAsPackaged}
        valueAsPrepared={valueAsPrepared}
      />
    );
  }

  return (
    <SingleColumnNutritionTableContentRow
      displayPercent={displayPercent}
      isHeader={isHeader}
      percentAsPackaged={percentAsPackaged}
      percentAsPrepared={percentAsPrepared}
      rowClass={rowClass}
      title={title}
      valueAsPackaged={valueAsPackaged}
      valueAsPrepared={valueAsPrepared}
      addedSugarsRow={addedSugarsRow}
    />
  );
};

NutritionTableContentRow.propTypes = {
  displayPercent: PropTypes.bool.isRequired,
  displayPreparedNutritionInfo: PropTypes.bool.isRequired,
  isHeader: PropTypes.bool.isRequired,
  percentAsPackaged: PropTypes.string.isRequired,
  percentAsPrepared: PropTypes.string.isRequired,
  rowClass: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  valueAsPackaged: PropTypes.string.isRequired,
  valueAsPrepared: PropTypes.string.isRequired,
  addedSugarsRow: PropTypes.bool.isRequired,
};

export default NutritionTableContentRow;
